<app-role-form-dialog></app-role-form-dialog>
<app-permission-view-dialog></app-permission-view-dialog>
<app-ag-grid-table
  *ngIf="columnSelection"
  [entity]="entity"
  [columnDefs]="columnDefs"
  [bulkUpdateColDefs]="bulkUpdateColDefs"
  [autopopulateSelect]="autopopulateSelect"
  [columnSelection]="columnSelection"
  [buildParams]="buildParams"
>
</app-ag-grid-table>